export default function WorkflowAutomationPage() {
  return (
    <div>
      <h1>Workflow Automation</h1>
    </div>
  );
}
